<template>
  <section>
    <HomeBanner
      :lift="lift"
      :aspectRatio="heroAspectRatio"
      sizes="(max-width: 480px) 300px, 600px"
      textRight
      :noAction="true"
    />
  </section>
</template>

<script>
import Vue from 'vue'
import HomeBanner from '@/views/Home/Banner.vue'

export default Vue.extend({
  name: 'Banner',
  components: { HomeBanner },
  props: {
    lift: {
      type: Object,
      required: true
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
    heroAspectRatio() {
      if (this.isMobile) return 0.93;
      return 2.5;
    },

  },
})
</script>

<style
  scoped
  lang="scss"
>

</style>